import { createSlice } from "@reduxjs/toolkit";

// Global state for the "Conflicting template detected" resolution modal
// (see components/TemplatePageComponents/GlobalTemplateConflictModal.jsx).
// Lives in Redux - rather than as page-local state - so the modal can be triggered by an
// async event (the background conflict scan finishing sometime after a template was
// created/updated - see redux/templateConflictsSlice.js's watchForTemplateConflict)
// regardless of which route the user has since navigated to.
const templateConflictModalSlice = createSlice({
  name: "templateConflictModal",
  initialState: {
    isOpen: false,
    // Real ids needed to call /suggest and /resolve on the conflict this modal is showing.
    conflictId: null,
    overlapPercent: null,
    // Both sides of the pair, same shape - the modal itself decides (via a dropdown) which
    // one is treated as "existing" (kept/shown in the box) vs "current" (refined, or deleted
    // on merge) so either side of the conflict can be the one that's kept.
    templateA: null, // { id, name, description }
    templateB: null, // { id, name, description }
  },
  reducers: {
    openTemplateConflictModal: (state, action) => {
      state.isOpen = true;
      state.conflictId = action.payload?.conflictId ?? null;
      state.overlapPercent = action.payload?.overlapPercent ?? null;
      state.templateA = action.payload?.templateA ?? null;
      state.templateB = action.payload?.templateB ?? null;
    },
    closeTemplateConflictModal: state => {
      state.isOpen = false;
      state.conflictId = null;
      state.overlapPercent = null;
      state.templateA = null;
      state.templateB = null;
    },
  },
});

export const { openTemplateConflictModal, closeTemplateConflictModal } = templateConflictModalSlice.actions;
export default templateConflictModalSlice.reducer;
